import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import RfqQuoteDetailProposedDetailsGrid from "@MasterBluePrint/Widgets/RfqQuoteDetail/RfqQuoteDetailProposedDetailsGrid";
import RfqQuoteDetailRequestedDetailsGrid from "@MasterBluePrint/Widgets/RfqQuoteDetail/RfqQuoteDetailRequestedDetailsGrid";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

type Props = ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailCustomerProductListStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
}

export const rfqQuoteDetailCustomerProductListStyles: RfqQuoteDetailCustomerProductListStyles = {
    wrapper: {
        css: css`
            padding: ${themeFontSizes.size20} 0 ${themeFontSizes.size15};
        `,
    },
    titleText: {
        variant: "h5",
        as: "h2",
        css: css`
            @media print {
                font-size: ${themeFontSizes.size18};
            }
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size18};
            font-weight: ${themeFontWeights.fontWeightForBold};
            letter-spacing: 0;
            line-height: ${themeFontSizes.size23};
            margin-bottom: 0;
        `,
    },
};

const styles = rfqQuoteDetailCustomerProductListStyles;

const RfqQuoteDetailCustomerProductList = ({ quoteState }: Props) => {
    const quote = quoteState.value;
    if (!quote) {
        return null;
    }

    return(
        <>
            <StyledWrapper {...styles.wrapper} className="quote-summary-title">
                <Typography {...styles.titleText} id="quoteSummaryTitle">
                    {translate("Quote Summary")}
                </Typography>
            </StyledWrapper>
        
            {(quote.status === "QuoteProposed" || quote.status === "Quote Proposed" ||  quote.status === "AwaitingApproval") ? (
                <RfqQuoteDetailProposedDetailsGrid />
            ) : (
                <RfqQuoteDetailRequestedDetailsGrid />
            )}
        </>
    ) 
};

export default connect(mapStateToProps)(RfqQuoteDetailCustomerProductList);
